// @flow
import { connect } from 'react-redux';
import PromotionCodeDetails from './PromotionCodeDetails';
import { setPromotion } from '../../../../../../modules/SignUp/Bonus/actions';

const onDelete = () => setPromotion(null);

const mapDispatchToProps = {
  onDelete,
};

export default connect(null, mapDispatchToProps)(PromotionCodeDetails);
